import { render, staticRenderFns } from "./CardTitle.vue?vue&type=template&id=3bf23442&scoped=true&"
var script = {}
import style0 from "./CardTitle.vue?vue&type=style&index=0&id=3bf23442&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf23442",
  null
  
)

export default component.exports